module.exports = __webpack_public_path__ + "static/media/goodnest_app7_preview.66171997.jpg";